import { render, staticRenderFns } from "./LivingOptionSubsections.vue?vue&type=template&id=c506b5aa&scoped=true"
import script from "./LivingOptionSubsections.vue?vue&type=script&lang=js"
export * from "./LivingOptionSubsections.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionSubsections.vue?vue&type=style&index=0&id=c506b5aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c506b5aa",
  null
  
)

export default component.exports